<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Ubah Pengaturan" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Pengaturan<span style="color: red">*</span></p>
                  <v-text-field
                    dense 
                    placeholder="Nama"
                    required 
                    outlined 
                    readonly
                    disabled
                    v-model="formData.nama"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Variabel Pengaturan<span style="color: red">*</span></p>
                  <v-text-field
                    dense
                    placeholder="Variabel"
                    required 
                    outlined 
                    readonly
                    disabled
                    v-model="formData.variable"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input mb-3">
                  <p class="label font-weight-bold mb-1">Rincian Pengaturan</p>
                  <v-textarea 
                  dense
                  rows="2"
                  hide-details 
                  placeholder="Rincian"
                  required
                  outlined
                  v-model="formData.detail"
                  @input="$v.formData.detail.$touch()"
                  @blur="$v.formData.detail.$touch()"
                  :error-messages="detailErrors"
                  />
                </div>
                <p style="color:red;">{{errorMessageRincian}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nilai Pengaturan</p>
                  <v-text-field 
                  dense
                  placeholder="Nilai"
                  required
                  outlined
                  v-model="formData.value"
                  @input="$v.formData.value.$touch()"
                  @blur="$v.formData.value.$touch()"
                  :error-messages="valueErrors"
                  />
                </div>
                <p style="color:red;">{{errorMessageValue}}</p>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="updateData()">Simpan</v-btn>&nbsp;
              </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>

    </v-container>
  </template>
  
  <script>
 import { apiServer } from "../../setup-axios";
 import { numeric, required } from "vuelidate/lib/validators";
  export default {
    data: () => ({
      errorMessageRincian: null,
      errorMessageValue: null,
      formData: {
        id: null,
        nama: null,
        variable: null,
        detail: null,
        value: null,
      },
    }),
    validations: {
      formData: {
        detail: {
          required,
        },
        value: {
          required,
        }
      },
    },
    mounted() {
      console.log("loading")
      this.getData();
    },
    computed: {
      detailErrors() {
        const errors = [];
        if (!this.$v.formData.detail.$dirty) return errors;
        !this.$v.formData.detail.required && errors.push("Rincian Pengaturan harus diisi");
        return errors;
      },
      valueErrors() {
        const errors = [];
        if (!this.$v.formData.value.$dirty) return errors;
        !this.$v.formData.value.required && errors.push("Nilai harus diisi");
        return errors;
      },
    },
    methods: {
      getData() {
        console.log("get data " + this.$route.params.id)
        apiServer
          .get("/pengaturan/detail/" + this.$route.params.id)
          .then(response => {
            console.log(response.data.data)
            this.formData = response.data.data;
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the 
            this.errorMessageRincian = error.response.data.message
          });
      },
      updateData() {
        this.$v.$touch()
        if (this.$v.$anyError) {
          return
        }
        this.errorMessageRincian = ""
        this.errorMessageValue = ""
        let updateData = new FormData()
        updateData.append("Id",this.formData.id)
        updateData.append("Nama",this.formData.nama)
        updateData.append("Variable",this.formData.variable)
        updateData.append("Detail",this.formData.detail)
        updateData.append("Value",this.formData.value)
        console.log(updateData)
        apiServer
            .put("/pengaturan/update",updateData)
            .then(response => {
              console.log("Successfully updated pengaturan:")
              console.log(response.data.data)
              localStorage.setItem('updateSuccess', "Pengaturan " + this.formData.nama + " berhasil diubah.")
              this.$router.push("/pengaturan")
            })
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              this.errorMessageRincian = error.response.data.message
            });
      },
      cancel() {
        this.$router.push('/pengaturan')
      },
    }
  }
  </script>
  